import { render } from "./FolderPicker.vue?vue&type=template&id=41e3a885&scoped=true&ts=true"
import script from "./FolderPicker.vue?vue&type=script&lang=ts"
export * from "./FolderPicker.vue?vue&type=script&lang=ts"

import "./FolderPicker.vue?vue&type=style&index=0&id=41e3a885&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e3a885"]])

export default __exports__